import gettext from 'js-utils/gettext';
import moment from 'js-utils/moment';
import momentTimezone from 'js-utils/moment-timezone';
import { getDateTimeAsMoment } from 'js-utils/datetime';
import { COMPARE_GRANULARITY, DEFAULT_TIME } from '../constants';

export const relativeEventDatesValidator = (
    startDate,
    startTime,
    endDate,
    endTime,
    startDateName,
    endDateName,
) => {
    let errors = {};

    if (!startDate || !endDate) {
        return errors;
    }

    let effectiveStartTime = startTime;
    let effectiveEndTime = endTime;

    // If neither start or end time is provided, just compare dates
    if (!effectiveStartTime || !effectiveEndTime) {
        // an explicit time needs to be provided for moment future proofing
        // see https://github.com/moment/moment/issues/1407
        effectiveEndTime = DEFAULT_TIME;
        effectiveStartTime = DEFAULT_TIME;
    }

    const startDatetime = getDateTimeAsMoment(startDate, effectiveStartTime);
    const endDatetime = getDateTimeAsMoment(endDate, effectiveEndTime);

    if (
        startDatetime &&
        endDatetime &&
        !startDatetime.isBefore(endDatetime, COMPARE_GRANULARITY)
    ) {
        errors = {
            [startDateName]: gettext('End date must be after start date.'),
            [endDateName]: gettext('End date must be after start date.'),
        };
    }

    return errors;
};

export const minStartDateTimeValidator = (
    startDate,
    startTime,
    eventId,
    startDateName,
) => {
    let errors = {};
    const startDateTime = getDateTimeAsMoment(startDate, startTime);
    const isNewEvent = !eventId;

    if (
        isNewEvent &&
        startDateTime &&
        startDateTime.isBefore(moment(), COMPARE_GRANULARITY)
    ) {
        errors = {
            [startDateName]: gettext('Event cannot be in the past.'),
        };
    }
    return errors;
};

export const relativePublishDateTimeValidator = (
    publishDate,
    publishTime,
    startDate,
    startTime,
    publishDateName,
) => {
    let errors = {};

    if (!publishDate || !startDate) {
        return errors;
    }

    let effectivePublishTime = publishTime;
    let effectiveStartTime = startTime;

    // If neither publish or start time is provided, just compare dates
    if (!effectivePublishTime || !effectiveStartTime) {
        // an explicit time needs to be provided for moment future proofing
        // see https://github.com/moment/moment/issues/1407
        effectivePublishTime = DEFAULT_TIME;
        effectiveStartTime = DEFAULT_TIME;
    }

    const startDatetime = getDateTimeAsMoment(startDate, effectiveStartTime);
    const publishDatetime = getDateTimeAsMoment(
        publishDate,
        effectivePublishTime,
    );

    if (
        publishDatetime &&
        startDatetime &&
        !startDatetime.isAfter(publishDatetime, COMPARE_GRANULARITY)
    ) {
        errors = {
            [publishDateName]: gettext(
                'Publish time must be before event start time.',
            ),
        };
    }

    return errors;
};

export const minPublishDateTimeValidatorWithTimezone = (
    publishDate,
    publishTime,
    publishDateName,
    eventTimezone,
) => {
    let errors = {};
    let publishDateTime;

    if (!eventTimezone) {
        return null;
    }

    if (publishDate && publishTime) {
        publishDateTime = momentTimezone.tz(
            `${publishDate} ${publishTime}`,
            'YYYY-MM-DD hh:mm a',
            eventTimezone,
        );
    }

    if (
        publishDateTime &&
        publishDateTime.isBefore(
            moment().tz(eventTimezone).add(10, 'minutes'),
            COMPARE_GRANULARITY,
        )
    ) {
        errors = {
            [publishDateName]: gettext(
                'Publish time must be at least 10 minutes in the future.',
            ),
        };
    }
    return errors;
};
